<div>
    <mat-table #table [dataSource]="vatReturnDataSource">
      <ng-container matColumnDef="boxNo">
        <mat-header-cell *matHeaderCellDef><div class="white-space-nowrap"> Box No.</div> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div class="white-space-nowrap">{{ element.boxNo }}</div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="vatDesc">
        <mat-header-cell *matHeaderCellDef>
          VAT Description
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.vatDesc }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="vatAmount">
        <mat-header-cell *matHeaderCellDef class="text-align-right">
          Amount
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          £ {{ element.vatAmount | numberPipe }}
        </mat-cell>
      </ng-container>
      <mat-header-row
        *matHeaderRowDef="vatReturnDisplayedColumns"
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: vatReturnDisplayedColumns"
      ></mat-row>
    </mat-table>
    <div *ngIf="noDataFound" class="text-align-center mt-1 fw-bold">
      No Data Found
    </div>
  </div>